
<i class="wm-user-avatar" [ngStyle]="customStyle.bgStyle">
  <span class="wm-avatar-title" name="wm-avatar-icon" [ngStyle]="customStyle.fontStyle">{{ userInitials}}</span>
  </i>
